import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICLegendChangeType } from 'src/app/services/labpartner.service.model';
import { NotificationService } from 'src/app/shared/notification.service';

export interface ICExcludeIncludeDialogComponentData {
  changeType: ICLegendChangeType; // true for exclude, false for include
  cassette?: string;
  currentLegend?: string;
  newLegend?: string;
}

@Component({
  selector: 'ic-exclude-include-dialog',
  templateUrl: './ic-exclude-include-dialog.component.html',
  styleUrls: ['./ic-exclude-include-dialog.component.scss'],
  standalone: false,
})
export class ICExcludeIncludeDialogComponent implements OnInit {
  ICLegendChangeType = ICLegendChangeType; // Import the enum for use in the template
  changeType: ICLegendChangeType = ICLegendChangeType.Exclude; // Default to exclude
  reason: string = '';
  cassette?: string;
  currentLegend?: string;
  newLegend?: string;

  constructor(
    public dialogRef: MatDialogRef<ICExcludeIncludeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICExcludeIncludeDialogComponentData,
    private notificationService: NotificationService,
  ) {
    this.changeType = data.changeType;
    this.cassette = data.cassette;
    this.currentLegend = data.currentLegend;
    this.newLegend = data.newLegend;
  }

  ngOnInit(): void {}

  save() {
    if (this.changeType === ICLegendChangeType.Exclude) {
      this.notificationService.success('Item excluded successfully, Please save to apply changes');
    } else if (this.changeType === ICLegendChangeType.Include) {
      this.notificationService.success('Item included successfully, Please save to apply changes');
    } else if (this.changeType === ICLegendChangeType.Move) {
      this.notificationService.success('Item moved successfully, Please save to apply changes');
    }
    this.dialogRef.close(this.reason);
  }

  cancel() {
    if (this.changeType === ICLegendChangeType.Exclude) {
      this.notificationService.warn('Exclusion cancelled');
    } else if (this.changeType === ICLegendChangeType.Include) {
      this.notificationService.warn('Inclusion cancelled');
    } else if (this.changeType === ICLegendChangeType.Move) {
      this.notificationService.warn('Move cancelled');
    }
    this.dialogRef.close(null);
  }
}
